export const CUSTOMIZING_LOADER = ['✨', 'Customizing your Simplesat account...']
export const FEEDBACK_VIEWS_LOADER = ['💬', 'Setting up feedback views...']
export const DASHBOARD_LOADER = ['🎯', 'Generating custom dashboard...']
export const CHECKLIST_LOADER = ['✅', 'Creating checklist items...']

export const SUCCESS_LOADER = ['🎉', 'All set! Navigating to dashboard...']



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/OnboardingLoading/constants.js